import React from "react";
import { Stack } from "@mui/material";

import { StyledNavStack, StyledNavButton } from "./styles";

export const SideNavBarV2 = ({
  tabs = [],
  value,
  setValue = () => {},
  EndComponent,
}) => {
  return (
    <StyledNavStack className="hub-nav-bar">
      <Stack gap="20px">
        {tabs?.map(({ id, icon, label }) => (
          <StyledNavButton
            key={label}
            label={label}
            size="small"
            onClick={() => setValue(id)}
            iconProps={{ size: 26 }}
            variant="text"
            active={id === value}
            {...(icon ? { icon } : {})}
          />
        ))}
      </Stack>
      {EndComponent || <div />}
    </StyledNavStack>
  );
};

export default SideNavBarV2;
